<template>
  <v-col>
    <template v-if="demo">
      <v-alert
        icon="mdi-shield-lock-outline"
        prominent
        text
        type="info"
      >
        We have protected (to avoid misuse of) our SMTP credentials form public
        while demo mode. For more details contact at info.codehas@gmail.com .
      </v-alert>
    </template>
    <template v-else>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="mail.from_email"
            label="E-mail Form"
            type="email"
            :error-messages="errors.getMessage('from_email')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="mail.reply_email"
            label="Reply To"
            type="email"
            :error-messages="errors.getMessage('reply_email')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="mail.mail_driver"
            :items="drivers"
            chips
            label="Select Drever"
            :error-messages="errors.getMessage('mail_driver')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-select
            v-model="mail.mail_encryption"
            :items="encryptions"
            chips
            label="Encryption"
            :error-messages="errors.getMessage('mail_encryption')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="mail.mail_host"
            label="Mail Host"
            :error-messages="errors.getMessage('mail_host')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="mail.mail_port"
            label="Mail Port"
            type="number"
            :error-messages="errors.getMessage('mail_port')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="mail.mail_user"
            label="Username"
            :error-messages="errors.getMessage('mail_user')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="mail.mail_password"
            label="Password"
            type="password"
            :error-messages="errors.getMessage('mail_password')"
          />
        </v-col>
        <v-btn
          class="info mt-5"
          @click="mailUpdate"
        >
          Update mail outgoing
        </v-btn>
      </v-row>
    </template>
  </v-col>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      drivers: ["smtp"],
      encryptions: ["ssl", "tls", "null"],
    };
  },
  computed: {
    ...mapGetters({
      demo: "configs/demo",
      errors: "validation/pull",
      mail: "configs/mail",
    }),
  },

  methods: {
    mailUpdate() {
      Event.$emit("updateConfigs", {
        path: "setting-mail-update",
        payload: this.mail,
      });
    },
  },
};
</script>
